'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colmo = require('../../mixins/colmo');

var _colmo2 = _interopRequireDefault(_colmo);

var _diablo = require('../../mixins/diablo');

var _diablo2 = _interopRequireDefault(_diablo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var animation = weex.requireModule('animation');
exports.default = {
  mixins: [_colmo2.default, _diablo2.default],
  props: {
    show: {
      type: Boolean,
      default: true
    },
    hasAnimation: {
      type: Boolean,
      default: true
    },
    duration: {
      type: [Number, String],
      default: 300
    },
    timingFunction: {
      type: Array,
      default: function _default() {
        return ['ease-in', 'ease-out'];
      }
    },
    opacity: {
      type: [Number, String],
      default: undefined
    },
    canAutoClose: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      show_: false,
      isIOS: weex.config.env.osName == 'iOS'
    };
  },

  watch: {
    show: {
      handler: function handler(val, oldVal) {
        var _this = this;

        if (val) {
          this.show_ = true;
          this.hasAnimation && setTimeout(function () {
            _this.appearOverlay(true);
          }, 20);
        } else {
          if (oldVal !== true) return;
          this.hasAnimation && this.appearOverlay(false, this.duration, function () {});
          setTimeout(function () {
            _this.show_ = false;
          }, 0);
        }
      },

      immediate: true
    }
  },
  computed: {
    overlayStyle: function overlayStyle() {
      return {
        opacity: this.hasAnimation ? 0 : 1,
        backgroundColor: this._isColmo ? 'rgba(21, 21, 21,' + this._opacity + ')' : this._isDiablo ? 'rgba(0, 0, 0, 0.6)' : 'rgba(30, 46, 55,' + this._opacity + ')'
      };
    },
    _opacity: function _opacity() {
      if (this.opacity !== undefined) return this.opacity;
      return this._isColmo ? 0.75 : 0.3;
    }
  },
  methods: {
    overlayClicked: function overlayClicked(e) {
      this.canAutoClose ? this.appearOverlay(false) : this.$emit('dofOverlayBodyClicked', {});
    },
    appearOverlay: function appearOverlay(bool) {
      var _this2 = this;

      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.duration;
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
      var hasAnimation = this.hasAnimation,
          timingFunction = this.timingFunction,
          canAutoClose = this.canAutoClose;

      var needEmit = !bool && canAutoClose;
      needEmit && this.$emit('dofOverlayBodyClicked', {});
      var overlayEl = this.$refs['midea-overlay'];
      if (hasAnimation && overlayEl) {
        animation.transition(overlayEl, {
          styles: {
            opacity: bool ? 1 : this.isIOS ? 0.05 : 0
          },
          duration: duration,
          timingFunction: timingFunction[bool ? 0 : 1],
          delay: 0
        }, function () {
          cb();
          needEmit && _this2.$emit('dofOverlayBodyClicked', {});
        });
      } else {
        cb();
        needEmit && this.$emit('dofOverlayBodyClicked', {});
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-overlay/index.vue
// module id = 355
// module chunks = 0 1